const SCHEME_PATTERN = /^[a-z][a-z0-9+.-]*:/i

export function normalizeCollectionLinkUrl(value: string): string {
  const trimmed = value.trim()
  if(!trimmed || SCHEME_PATTERN.test(trimmed)) {
    return trimmed
  }
  return `https://${trimmed.replace(/^\/+/, '')}`
}
